/* eslint-disable max-lines */
/* eslint-disable complexity */
import {
  BookWidgetAem,
  BookWidgetAirport,
  BookWidgetAirportField,
  BookWidgetFields,
  TripTypeOptions
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BOOK_WIDGET_ERROR_CODES } from '../../constants/error-codes.constants';
import { isAirportCodeValid } from '../utils/utils.adapter';

export const validateAirports = (
  bookWidgetFields: BookWidgetFields,
  fieldsErrorCount: number,
  startFieldsValidation: boolean,
  bookWidgetAem: BookWidgetAem | null
) => {
  const updatedBookWidgetFields: BookWidgetFields = {
    ...bookWidgetFields,
    airportsField: { ...bookWidgetFields.airportsField }
  };

  delete updatedBookWidgetFields.airportsField.fieldErrorInfo;

  if (startFieldsValidation) {
    const { airportsField, tripTypesField } = updatedBookWidgetFields;
    const tripType = tripTypesField.selectedTripType;

    if (tripType === TripTypeOptions.MULTI_CITY) {
      fieldsErrorCount = validateMultiCityAirports(
        airportsField,
        fieldsErrorCount,
        bookWidgetAem
      );
    } else {
      fieldsErrorCount = validateOwRtAirports(
        airportsField,
        fieldsErrorCount,
        bookWidgetAem
      );
    }
  }

  return { fieldsErrorCount, updatedBookWidgetFields };
};

const getErrorMessages = (bookWidgetAem: BookWidgetAem | null) => {
  const invalidConnectionError =
    bookWidgetAem?.errorMessages?.[
      BOOK_WIDGET_ERROR_CODES.BOOK_FIELD_ERROR_INVALID_CONNECTION_AIRPORT
    ]?.message || 'Error';

  const destinationErrorMessage =
    bookWidgetAem?.errorMessages?.[
      BOOK_WIDGET_ERROR_CODES.BOOK_FIELD_ERROR_MISSING_DESTINATION
    ]?.message || 'Error';
  const originErrorMessage =
    bookWidgetAem?.errorMessages?.[
      BOOK_WIDGET_ERROR_CODES.BOOK_FIELD_ERROR_MISSING_ORIGIN
    ]?.message || 'Error';
  const sameRouteErrorMessage =
    bookWidgetAem?.errorMessages?.[
      BOOK_WIDGET_ERROR_CODES.BOOK_FIELD_ERROR_SAME_ORIGIN_DESTINATION
    ]?.message || 'Error';

  const bothFieldsErrorMessage =
    bookWidgetAem?.errorMessages?.[
      BOOK_WIDGET_ERROR_CODES.BOOK_FIELD_ERROR_MISSING_ORIGIN_DESTINATION
    ]?.message || 'Error';

  return {
    invalidConnectionError,
    destinationErrorMessage,
    originErrorMessage,
    sameRouteErrorMessage,
    bothFieldsErrorMessage
  };
};

const validateAirportRoute = (
  airport: BookWidgetAirport,
  bookWidgetAem: BookWidgetAem | null
) => {
  let destination = false;
  let origin = false;
  let sameRoute = false;
  let errorCount = 0;

  if (
    !airport.toAirportcode ||
    airport.toAirportcode?.length < 3 ||
    !isAirportCodeValid(airport.toAirportcode)
  ) {
    destination = true;
    errorCount++;
  }

  if (
    !airport.fromAirportcode ||
    airport.fromAirportcode?.length < 3 ||
    !isAirportCodeValid(airport.fromAirportcode)
  ) {
    origin = true;
    errorCount++;
  }

  if (
    airport.toAirportcode &&
    airport.fromAirportcode &&
    airport.toAirportcode === airport.fromAirportcode
  ) {
    sameRoute = true;
    destination = true;
    errorCount++;
  }

  const {
    destinationErrorMessage,
    originErrorMessage,
    sameRouteErrorMessage,
    invalidConnectionError,
    bothFieldsErrorMessage
  } = getErrorMessages(bookWidgetAem);

  return {
    destination,
    origin,
    sameRoute,
    destinationErrorMessage,
    originErrorMessage,
    sameRouteErrorMessage,
    bothFieldsErrorMessage,
    errorCount,
    invalidConnectionError
  };
};

const validateMultiCityAirports = (
  airportsField: BookWidgetAirportField,
  fieldsErrorCount: number,
  bookWidgetAem: BookWidgetAem | null
): number => {
  airportsField.fieldErrorInfo = {
    routePickerField: [],
    connectionAirportField: []
  };

  airportsField.airports.forEach((airport) => {
    const routeValidation = validateAirportRoute(airport, bookWidgetAem);
    fieldsErrorCount += routeValidation.errorCount;

    airportsField.fieldErrorInfo?.routePickerField.push({
      destination: routeValidation.destination,
      origin: routeValidation.origin,
      sameRoute: routeValidation.sameRoute,
      destinationErrorMessage: routeValidation.destinationErrorMessage,
      originErrorMessage: routeValidation.originErrorMessage,
      sameRouteErrorMessage: routeValidation.sameRouteErrorMessage,
      bothFieldsErrorMessage: routeValidation.bothFieldsErrorMessage
    });

    if (
      airport.connectionAirport &&
      (airport.connectionAirport === airport.toAirportcode ||
        airport.connectionAirport === airport.fromAirportcode)
    ) {
      airportsField.fieldErrorInfo?.connectionAirportField?.push({
        errorMessage: routeValidation.invalidConnectionError
      });
      fieldsErrorCount++;
    } else {
      airportsField.fieldErrorInfo?.connectionAirportField?.push({
        errorMessage: ''
      });
    }
  });

  return fieldsErrorCount;
};

const validateOwRtAirports = (
  airportsField: BookWidgetAirportField,
  fieldsErrorCount: number,
  bookWidgetAem: BookWidgetAem | null
): number => {
  const routeValidation = validateAirportRoute(
    airportsField.airports[0],
    bookWidgetAem
  );
  fieldsErrorCount += routeValidation.errorCount;

  airportsField.fieldErrorInfo = {
    routePickerField: [
      {
        destination: routeValidation.destination,
        origin: routeValidation.origin,
        sameRoute: routeValidation.sameRoute,
        destinationErrorMessage: routeValidation.destinationErrorMessage,
        originErrorMessage: routeValidation.originErrorMessage,
        sameRouteErrorMessage: routeValidation.sameRouteErrorMessage,
        bothFieldsErrorMessage: routeValidation.bothFieldsErrorMessage
      }
    ]
  };

  return fieldsErrorCount;
};
